var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#960B03",
    d: "M9.768 1.185c-.355-.692-1.181-.692-1.536 0L.807 15.647c-.379.733.056 1.686.767 1.686h14.852c.712 0 1.146-.953.768-1.686L9.77 1.185Zm-.762 2.4 6.244 12.082H2.752L9.006 3.585ZM7.75 13.583a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm.417-2.916c0 .555.278.833.833.833.556 0 .833-.278.833-.833V7.333c0-.555-.277-.833-.833-.833-.555 0-.833.278-.833.833v3.334Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/redAlert.dc394b169785f599a064bf2b7ee384b6.svg";
export { ForwardRef as ReactComponent };